import React from 'react';
import type { FC } from 'react';
import { useParams } from 'react-router';

import { useTitle } from '@admin/hooks/use_title';
import { client } from '@admin/libraries/apollo';
import {
  Hiring__JobListing__Input,
  Status,
  useHiringJobListingDetailsQuery,
  useHiringJobListingUpdateMutation,
} from '@admin/schema';
import { encodeWarehouseOrDepot } from '@admin/utils/warehouse_or_depots';

import { HiringJobListingForm } from './form';

export const HiringJobListingEdit: FC = () => {
  useTitle('Hiring | Job Listing | Edit');
  const { id } = useParams<{ id: string }>();
  const { data: details } = useHiringJobListingDetailsQuery({ client, variables: { id } });
  const [execute, { loading: saving, data }] = useHiringJobListingUpdateMutation({
    client,
    onCompleted: ({ result }) => {
      if (result?.status === Status.Ok) window.location.href = '/hiring/job_listings';
    },
  });

  const save = (input: Hiring__JobListing__Input) => {
    execute({ variables: { id, input } });
  };

  const error = data?.result?.error;

  const defaults = details?.hiringJobListing && {
    jobID: details.hiringJobListing.job.id,
    regionID: details.hiringJobListing.region.id,
    encodedWarehouseOrDepot: encodeWarehouseOrDepot(details.hiringJobListing.warehouseOrDepot),
    googleSchedulerLink: details.hiringJobListing.googleSchedulerLink ?? '',
    hourlyRate: details.hiringJobListing.hourlyRate,
    fullTime: details.hiringJobListing.fullTime ? 'true' : 'false',
    nightShift: details.hiringJobListing.nightShift ? 'true' : 'false',
    workdayApplicationLink: details.hiringJobListing.workdayApplicationLink ?? '',
  };

  if (!defaults) return null;

  return <HiringJobListingForm save={save} saving={saving} error={error} defaults={defaults} />;
};
